import { render, staticRenderFns } from "./collDetail.vue?vue&type=template&id=515d64ba&scoped=true&"
import script from "./collDetail.vue?vue&type=script&lang=js&"
export * from "./collDetail.vue?vue&type=script&lang=js&"
import style0 from "./collDetail.vue?vue&type=style&index=0&id=515d64ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d64ba",
  null
  
)

export default component.exports